import { InputSelectCampaignController } from './input-select-campaign.controller'

function inputSelectCampaign () {
  return {
    restrict: 'E',
    scope: {
      campaigns: '<',
      getAllCampaigns: '&',
      currentModule: '<',
      selectedCampaign: '=',
      currentCampaignId: '<',
      disabled: '<',
      onChange: '<'
    },
    templateUrl: '/core/directives/input-select-campaign/input-select-campaign-directive.html?$$REVISION$$',
    controller: InputSelectCampaignController
  }
}

export { inputSelectCampaign }
